'use client'

import React, { useState } from "react";
import { Box, Collapse, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/pro-duotone-svg-icons";

const Collapsible = (
    {
        isOpen,
        label,
        children
    }: {
        isOpen: boolean,
        label: string,
        children: React.ReactNode
    }
) => {
    const [isExpanded, setIsExpanded] = useState(isOpen);

    const handleCollapse = () => {
        setIsExpanded(!isExpanded);
    }

    return (
        <>
            <Box 
                display="flex" 
                alignItems="center"
                onClick={handleCollapse}    
            >
                <Typography 
                    component="span" 
                    color="primary.main" 
                    fontSize={'.8rem'}
                    mr={.25}
                >
                    <FontAwesomeIcon 
                        icon={faChevronDown} 
                        style={{ transform: `rotate(${isExpanded ? 0 : -90}deg)` }} 
                    />
                </Typography>
                <Typography component="span" color="primary.main">
                    {
                        label
                    }
                </Typography>
            </Box>
            <Collapse in={isExpanded}>
                {
                    children
                }
            </Collapse>
        </>
    )
}

export default Collapsible;